import { render } from "./DetalleLosetaMapa.vue?vue&type=template&id=ae4b5582"
import script from "./DetalleLosetaMapa.vue?vue&type=script&lang=js"
export * from "./DetalleLosetaMapa.vue?vue&type=script&lang=js"

import "./DetalleLosetaMapa.vue?vue&type=style&index=0&id=ae4b5582&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__